import { dmAdminApiBase as api } from './dmAdminApiBase';

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    capabilityControllerListDeviceModels: build.query<
      CapabilityControllerListDeviceModelsApiResponse,
      CapabilityControllerListDeviceModelsApiArg
    >({
      query: queryArg => ({
        url: `/capability/deviceModels`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          sort: queryArg.sort,
          search: queryArg.search,
        },
      }),
    }),
    capabilityControllerCreateDeviceModel: build.mutation<
      CapabilityControllerCreateDeviceModelApiResponse,
      CapabilityControllerCreateDeviceModelApiArg
    >({
      query: queryArg => ({
        url: `/capability/deviceModels`,
        method: 'POST',
        body: queryArg.createDeviceModelDto,
      }),
    }),
    capabilityControllerGetDeviceModel: build.query<
      CapabilityControllerGetDeviceModelApiResponse,
      CapabilityControllerGetDeviceModelApiArg
    >({
      query: queryArg => ({ url: `/capability/deviceModels/${queryArg.id}` }),
    }),
    capabilityControllerUpdateDeviceModel: build.mutation<
      CapabilityControllerUpdateDeviceModelApiResponse,
      CapabilityControllerUpdateDeviceModelApiArg
    >({
      query: queryArg => ({
        url: `/capability/deviceModels/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.updateDeviceModelDto,
      }),
    }),
    capabilityControllerDeleteDeviceModel: build.mutation<
      CapabilityControllerDeleteDeviceModelApiResponse,
      CapabilityControllerDeleteDeviceModelApiArg
    >({
      query: queryArg => ({
        url: `/capability/deviceModels/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    capabilityControllerListCapabilityKeys: build.query<
      CapabilityControllerListCapabilityKeysApiResponse,
      CapabilityControllerListCapabilityKeysApiArg
    >({
      query: queryArg => ({
        url: `/capability/keys`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          sort: queryArg.sort,
          search: queryArg.search,
        },
      }),
    }),
    capabilityControllerCreateCapabilityKey: build.mutation<
      CapabilityControllerCreateCapabilityKeyApiResponse,
      CapabilityControllerCreateCapabilityKeyApiArg
    >({
      query: queryArg => ({
        url: `/capability/keys`,
        method: 'POST',
        body: queryArg.createCapabilityKeyDto,
      }),
    }),
    capabilityControllerUpdateCapabilityKey: build.mutation<
      CapabilityControllerUpdateCapabilityKeyApiResponse,
      CapabilityControllerUpdateCapabilityKeyApiArg
    >({
      query: queryArg => ({
        url: `/capability/keys/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.updateCapabilityKeyDto,
      }),
    }),
    capabilityControllerDeleteCapabilityKey: build.mutation<
      CapabilityControllerDeleteCapabilityKeyApiResponse,
      CapabilityControllerDeleteCapabilityKeyApiArg
    >({
      query: queryArg => ({
        url: `/capability/keys/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    capabilityControllerListCapabilityVersions: build.query<
      CapabilityControllerListCapabilityVersionsApiResponse,
      CapabilityControllerListCapabilityVersionsApiArg
    >({
      query: queryArg => ({
        url: `/capability/versions`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          deviceModelId: queryArg.deviceModelId,
          fwVersion: queryArg.fwVersion,
          sort: queryArg.sort,
        },
      }),
    }),
    capabilityControllerCreateCapabilityVersion: build.mutation<
      CapabilityControllerCreateCapabilityVersionApiResponse,
      CapabilityControllerCreateCapabilityVersionApiArg
    >({
      query: queryArg => ({
        url: `/capability/versions`,
        method: 'POST',
        body: queryArg.createCapabilityVersionDto,
      }),
    }),
    capabilityControllerDeleteCapabilityVersion: build.mutation<
      CapabilityControllerDeleteCapabilityVersionApiResponse,
      CapabilityControllerDeleteCapabilityVersionApiArg
    >({
      query: queryArg => ({
        url: `/capability/versions/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    capabilityControllerListDeviceCapabilities: build.query<
      CapabilityControllerListDeviceCapabilitiesApiResponse,
      CapabilityControllerListDeviceCapabilitiesApiArg
    >({
      query: queryArg => ({
        url: `/capability/deviceCapabilities`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          capabilityVersionId: queryArg.capabilityVersionId,
          capabilityKeyId: queryArg.capabilityKeyId,
          capability: queryArg.capability,
          note: queryArg.note,
        },
      }),
    }),
    capabilityControllerBulkUpdateDeviceCapabilities: build.mutation<
      CapabilityControllerBulkUpdateDeviceCapabilitiesApiResponse,
      CapabilityControllerBulkUpdateDeviceCapabilitiesApiArg
    >({
      query: queryArg => ({
        url: `/capability/deviceCapabilities/bulk`,
        method: 'PATCH',
        body: queryArg.body,
      }),
    }),
    capabilityControllerUpdateDeviceCapability: build.mutation<
      CapabilityControllerUpdateDeviceCapabilityApiResponse,
      CapabilityControllerUpdateDeviceCapabilityApiArg
    >({
      query: queryArg => ({
        url: `/capability/deviceCapabilities/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.updateDeviceCapabilityDto,
      }),
    }),
    capabilityControllerDeleteDeviceCapability: build.mutation<
      CapabilityControllerDeleteDeviceCapabilityApiResponse,
      CapabilityControllerDeleteDeviceCapabilityApiArg
    >({
      query: queryArg => ({
        url: `/capability/deviceCapabilities/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    featureControllerList: build.query<
      FeatureControllerListApiResponse,
      FeatureControllerListApiArg
    >({
      query: queryArg => ({
        url: `/features`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          mode: queryArg.mode,
          search: queryArg.search,
        },
      }),
    }),
    featureControllerCreate: build.mutation<
      FeatureControllerCreateApiResponse,
      FeatureControllerCreateApiArg
    >({
      query: queryArg => ({
        url: `/features`,
        method: 'POST',
        body: queryArg.createFeatureDto,
      }),
    }),
    featureControllerGet: build.query<
      FeatureControllerGetApiResponse,
      FeatureControllerGetApiArg
    >({
      query: queryArg => ({ url: `/features/${queryArg.key}` }),
    }),
    featureControllerUpdate: build.mutation<
      FeatureControllerUpdateApiResponse,
      FeatureControllerUpdateApiArg
    >({
      query: queryArg => ({
        url: `/features/${queryArg.key}`,
        method: 'PATCH',
        body: queryArg.updateFeatureDto,
      }),
    }),
    featureControllerListRules: build.query<
      FeatureControllerListRulesApiResponse,
      FeatureControllerListRulesApiArg
    >({
      query: queryArg => ({
        url: `/features/${queryArg.key}/rules`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          type: queryArg['type'],
          search: queryArg.search,
        },
      }),
    }),
    featureControllerAddRules: build.mutation<
      FeatureControllerAddRulesApiResponse,
      FeatureControllerAddRulesApiArg
    >({
      query: queryArg => ({
        url: `/features/${queryArg.key}/rules`,
        method: 'POST',
        body: queryArg.addFeatureRulesDto,
      }),
    }),
    featureControllerDeleteRule: build.mutation<
      FeatureControllerDeleteRuleApiResponse,
      FeatureControllerDeleteRuleApiArg
    >({
      query: queryArg => ({
        url: `/features/${queryArg.key}/rules/${queryArg.ruleId}`,
        method: 'DELETE',
      }),
    }),
    entityGroupControllerList: build.query<
      EntityGroupControllerListApiResponse,
      EntityGroupControllerListApiArg
    >({
      query: queryArg => ({
        url: `/entity-groups`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          search: queryArg.search,
        },
      }),
    }),
    entityGroupControllerCreate: build.mutation<
      EntityGroupControllerCreateApiResponse,
      EntityGroupControllerCreateApiArg
    >({
      query: queryArg => ({
        url: `/entity-groups`,
        method: 'POST',
        body: queryArg.createEntityGroupDto,
      }),
    }),
    entityGroupControllerGet: build.query<
      EntityGroupControllerGetApiResponse,
      EntityGroupControllerGetApiArg
    >({
      query: queryArg => ({ url: `/entity-groups/${queryArg.id}` }),
    }),
    entityGroupControllerUpdate: build.mutation<
      EntityGroupControllerUpdateApiResponse,
      EntityGroupControllerUpdateApiArg
    >({
      query: queryArg => ({
        url: `/entity-groups/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.updateEntityGroupDto,
      }),
    }),
    entityGroupControllerDelete: build.mutation<
      EntityGroupControllerDeleteApiResponse,
      EntityGroupControllerDeleteApiArg
    >({
      query: queryArg => ({
        url: `/entity-groups/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    entityGroupControllerListMembers: build.query<
      EntityGroupControllerListMembersApiResponse,
      EntityGroupControllerListMembersApiArg
    >({
      query: queryArg => ({
        url: `/entity-groups/${queryArg.id}/members`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          search: queryArg.search,
        },
      }),
    }),
    entityGroupControllerAddMembers: build.mutation<
      EntityGroupControllerAddMembersApiResponse,
      EntityGroupControllerAddMembersApiArg
    >({
      query: queryArg => ({
        url: `/entity-groups/${queryArg.id}/members`,
        method: 'POST',
        body: queryArg.addEntityGroupMembersDto,
      }),
    }),
    entityGroupControllerDeleteMember: build.mutation<
      EntityGroupControllerDeleteMemberApiResponse,
      EntityGroupControllerDeleteMemberApiArg
    >({
      query: queryArg => ({
        url: `/entity-groups/${queryArg.id}/members/${queryArg.memberId}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as dmAdminApiInjected };
export type CapabilityControllerListDeviceModelsApiResponse =
  /** status 200  */ ListDeviceModelsResponseDto;
export type CapabilityControllerListDeviceModelsApiArg = {
  /** 1-based page number. */
  page?: number;
  /** Page size; 0 returns all rows without paging. */
  limit?: number;
  /** Leading `-` sorts descending. Omitted: newest first. */
  sort?: 'modelName' | '-modelName';
  /** Case-insensitive substring match on modelName / displayName / regExp / note (OR); an integer also matches osVersion. */
  search?: string;
};
export type CapabilityControllerCreateDeviceModelApiResponse =
  /** status 201  */ DeviceModelResponseDto;
export type CapabilityControllerCreateDeviceModelApiArg = {
  createDeviceModelDto: CreateDeviceModelDto;
};
export type CapabilityControllerGetDeviceModelApiResponse =
  /** status 200  */ DeviceModelResponseDto;
export type CapabilityControllerGetDeviceModelApiArg = {
  id: string;
};
export type CapabilityControllerUpdateDeviceModelApiResponse =
  /** status 200  */ DeviceModelResponseDto;
export type CapabilityControllerUpdateDeviceModelApiArg = {
  id: string;
  updateDeviceModelDto: UpdateDeviceModelDto;
};
export type CapabilityControllerDeleteDeviceModelApiResponse =
  /** status 200  */ DeviceModelResponseDto;
export type CapabilityControllerDeleteDeviceModelApiArg = {
  id: string;
};
export type CapabilityControllerListCapabilityKeysApiResponse =
  /** status 200  */ ListCapabilityKeysResponseDto;
export type CapabilityControllerListCapabilityKeysApiArg = {
  /** 1-based page number. */
  page?: number;
  /** Page size; 0 returns all rows without paging. */
  limit?: number;
  /** Leading `-` sorts descending. Omitted: newest first. */
  sort?: 'name' | '-name';
  /** Case-insensitive substring match on name / description (OR). */
  search?: string;
};
export type CapabilityControllerCreateCapabilityKeyApiResponse =
  /** status 201  */ CapabilityKeyResponseDto;
export type CapabilityControllerCreateCapabilityKeyApiArg = {
  createCapabilityKeyDto: CreateCapabilityKeyDto;
};
export type CapabilityControllerUpdateCapabilityKeyApiResponse =
  /** status 200  */ CapabilityKeyResponseDto;
export type CapabilityControllerUpdateCapabilityKeyApiArg = {
  id: string;
  updateCapabilityKeyDto: UpdateCapabilityKeyDto;
};
export type CapabilityControllerDeleteCapabilityKeyApiResponse =
  /** status 200  */ CapabilityKeyResponseDto;
export type CapabilityControllerDeleteCapabilityKeyApiArg = {
  id: string;
};
export type CapabilityControllerListCapabilityVersionsApiResponse =
  /** status 200  */ ListCapabilityVersionsResponseDto;
export type CapabilityControllerListCapabilityVersionsApiArg = {
  /** 1-based page number. */
  page?: number;
  /** Page size; 0 returns all rows without paging. */
  limit?: number;
  deviceModelId?: string;
  /** Case-insensitive substring match. */
  fwVersion?: string;
  /** Leading `-` sorts descending. Omitted: newest first. */
  sort?: 'fwVersion' | '-fwVersion';
};
export type CapabilityControllerCreateCapabilityVersionApiResponse =
  /** status 201  */ CapabilityVersionWithModelResponseDto;
export type CapabilityControllerCreateCapabilityVersionApiArg = {
  createCapabilityVersionDto: CreateCapabilityVersionDto;
};
export type CapabilityControllerDeleteCapabilityVersionApiResponse =
  /** status 200  */ CapabilityVersionWithModelResponseDto;
export type CapabilityControllerDeleteCapabilityVersionApiArg = {
  id: string;
};
export type CapabilityControllerListDeviceCapabilitiesApiResponse =
  /** status 200  */ ListDeviceCapabilitiesResponseDto;
export type CapabilityControllerListDeviceCapabilitiesApiArg = {
  /** 1-based page number. */
  page?: number;
  /** Page size; 0 returns all rows without paging. */
  limit?: number;
  capabilityVersionId?: string;
  capabilityKeyId?: string;
  capability?: boolean;
  /** Case-insensitive substring match. */
  note?: string;
};
export type CapabilityControllerBulkUpdateDeviceCapabilitiesApiResponse =
  /** status 200  */ DeviceCapabilityResponseDto[];
export type CapabilityControllerBulkUpdateDeviceCapabilitiesApiArg = {
  body: BulkUpdateDeviceCapabilityItemDto[];
};
export type CapabilityControllerUpdateDeviceCapabilityApiResponse =
  /** status 200  */ DeviceCapabilityResponseDto;
export type CapabilityControllerUpdateDeviceCapabilityApiArg = {
  id: string;
  updateDeviceCapabilityDto: UpdateDeviceCapabilityDto;
};
export type CapabilityControllerDeleteDeviceCapabilityApiResponse =
  /** status 200  */ DeviceCapabilityResponseDto;
export type CapabilityControllerDeleteDeviceCapabilityApiArg = {
  id: string;
};
export type FeatureControllerListApiResponse =
  /** status 200  */ ListFeaturesResponseDto;
export type FeatureControllerListApiArg = {
  /** 1-based page number. */
  page?: number;
  /** Page size; 0 returns all rows without paging. */
  limit?: number;
  mode?: 'all' | 'restricted' | 'none';
  /** Case-insensitive substring match on key / name (OR). */
  search?: string;
};
export type FeatureControllerCreateApiResponse =
  /** status 201  */ FeatureResponseDto;
export type FeatureControllerCreateApiArg = {
  createFeatureDto: CreateFeatureDto;
};
export type FeatureControllerGetApiResponse =
  /** status 200  */ FeatureResponseDto;
export type FeatureControllerGetApiArg = {
  key: string;
};
export type FeatureControllerUpdateApiResponse =
  /** status 200  */ FeatureResponseDto;
export type FeatureControllerUpdateApiArg = {
  key: string;
  updateFeatureDto: UpdateFeatureDto;
};
export type FeatureControllerListRulesApiResponse =
  /** status 200  */ ListFeatureRulesResponseDto;
export type FeatureControllerListRulesApiArg = {
  key: string;
  /** 1-based page number. */
  page?: number;
  /** Page size; 0 returns all rows without paging. */
  limit?: number;
  type?: 'entity' | 'country' | 'region' | 'group';
  /** Case-insensitive substring match on value / note / group name (OR). */
  search?: string;
};
export type FeatureControllerAddRulesApiResponse =
  /** status 201  */ AddFeatureRulesResponseDto;
export type FeatureControllerAddRulesApiArg = {
  key: string;
  addFeatureRulesDto: AddFeatureRulesDto;
};
export type FeatureControllerDeleteRuleApiResponse =
  /** status 200  */ FeatureRuleResponseDto;
export type FeatureControllerDeleteRuleApiArg = {
  key: string;
  ruleId: string;
};
export type EntityGroupControllerListApiResponse =
  /** status 200  */ ListEntityGroupsResponseDto;
export type EntityGroupControllerListApiArg = {
  /** 1-based page number. */
  page?: number;
  /** Page size; 0 returns all rows without paging. */
  limit?: number;
  /** Case-insensitive substring match on name. */
  search?: string;
};
export type EntityGroupControllerCreateApiResponse =
  /** status 201  */ EntityGroupResponseDto;
export type EntityGroupControllerCreateApiArg = {
  createEntityGroupDto: CreateEntityGroupDto;
};
export type EntityGroupControllerGetApiResponse =
  /** status 200  */ EntityGroupDetailResponseDto;
export type EntityGroupControllerGetApiArg = {
  id: string;
};
export type EntityGroupControllerUpdateApiResponse =
  /** status 200  */ EntityGroupDetailResponseDto;
export type EntityGroupControllerUpdateApiArg = {
  id: string;
  updateEntityGroupDto: UpdateEntityGroupDto;
};
export type EntityGroupControllerDeleteApiResponse =
  /** status 200 The deleted group; `usedByCount` is 0. */ EntityGroupResponseDto;
export type EntityGroupControllerDeleteApiArg = {
  id: string;
};
export type EntityGroupControllerListMembersApiResponse =
  /** status 200  */ ListEntityGroupMembersResponseDto;
export type EntityGroupControllerListMembersApiArg = {
  id: string;
  /** 1-based page number. */
  page?: number;
  /** Page size; 0 returns all rows without paging. */
  limit?: number;
  /** Case-insensitive substring match on entity id / note (OR). */
  search?: string;
};
export type EntityGroupControllerAddMembersApiResponse =
  /** status 201  */ AddEntityGroupMembersResponseDto;
export type EntityGroupControllerAddMembersApiArg = {
  id: string;
  addEntityGroupMembersDto: AddEntityGroupMembersDto;
};
export type EntityGroupControllerDeleteMemberApiResponse =
  /** status 200  */ EntityGroupMemberResponseDto;
export type EntityGroupControllerDeleteMemberApiArg = {
  id: string;
  memberId: string;
};
export type DeviceModelResponseDto = {
  id: string;
  modelName: string;
  osVersion: number | null;
  displayName: string;
  regExp: string;
  note: string | null;
  createdAt: string;
  updatedAt: string;
};
export type ListDeviceModelsResponseDto = {
  totalDocs: number;
  totalPages: number;
  /** 1-based. */
  page: number;
  /** 0 when the request asked for all rows. */
  limit: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number | null;
  prevPage: number | null;
  docs: DeviceModelResponseDto[];
};
export type CreateDeviceModelDto = {
  modelName: string;
  displayName: string;
  /** Matched against the device model reported by the device (dm-iot). */
  regExp: string;
  /** Android major version; null matches any. */
  osVersion?: number | null;
  note?: string | null;
};
export type UpdateDeviceModelDto = {
  modelName?: string;
  displayName?: string;
  /** Matched against the device model reported by the device (dm-iot). */
  regExp?: string;
  /** Android major version; null matches any. */
  osVersion?: number | null;
  note?: string | null;
};
export type CapabilityKeyResponseDto = {
  id: string;
  name: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
};
export type ListCapabilityKeysResponseDto = {
  totalDocs: number;
  totalPages: number;
  /** 1-based. */
  page: number;
  /** 0 when the request asked for all rows. */
  limit: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number | null;
  prevPage: number | null;
  docs: CapabilityKeyResponseDto[];
};
export type CreateCapabilityKeyDto = {
  /** Unique; this is the key dm-iot hands to devices. */
  name: string;
  description?: string | null;
};
export type UpdateCapabilityKeyDto = {
  /** Unique; this is the key dm-iot hands to devices. */
  name?: string;
  description?: string | null;
};
export type CapabilityVersionWithModelResponseDto = {
  id: string;
  deviceModelId: string;
  fwVersion: string;
  createdAt: string;
  updatedAt: string;
  deviceModel: DeviceModelResponseDto;
};
export type ListCapabilityVersionsResponseDto = {
  totalDocs: number;
  totalPages: number;
  /** 1-based. */
  page: number;
  /** 0 when the request asked for all rows. */
  limit: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number | null;
  prevPage: number | null;
  docs: CapabilityVersionWithModelResponseDto[];
};
export type CreateCapabilityVersionDto = {
  deviceModelId: string;
  /** Unique per device model. */
  fwVersion: string;
  /** Copy which keys are switched on from this version; omitted, every key starts off. */
  baseCapabilityVersionId?: string;
};
export type CapabilityVersionResponseDto = {
  id: string;
  deviceModelId: string;
  fwVersion: string;
  createdAt: string;
  updatedAt: string;
};
export type DeviceCapabilityResponseDto = {
  id: string;
  capabilityKeyId: string;
  capabilityVersionId: string;
  capability: boolean;
  note: string | null;
  createdAt: string;
  updatedAt: string;
  capabilityKey: CapabilityKeyResponseDto;
  capabilityVersion: CapabilityVersionResponseDto;
};
export type ListDeviceCapabilitiesResponseDto = {
  totalDocs: number;
  totalPages: number;
  /** 1-based. */
  page: number;
  /** 0 when the request asked for all rows. */
  limit: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number | null;
  prevPage: number | null;
  docs: DeviceCapabilityResponseDto[];
};
export type BulkUpdateDeviceCapabilityItemDto = {
  capability?: boolean;
  note?: string | null;
  id: string;
};
export type UpdateDeviceCapabilityDto = {
  capability?: boolean;
  note?: string | null;
};
export type FeatureRuleCountDto = {
  entity: number;
  country: number;
  region: number;
  group: number;
};
export type FeatureResponseDto = {
  key: string;
  name: string;
  description: string | null;
  mode: 'all' | 'restricted' | 'none';
  /** Rules per type; kept whatever the mode. */
  ruleCount: FeatureRuleCountDto;
  /** Email, or `seeder`. */
  createdBy: string;
  /** Who last changed the mode. */
  updatedBy: string | null;
  updatedAt: string;
};
export type ListFeaturesResponseDto = {
  totalDocs: number;
  totalPages: number;
  /** 1-based. */
  page: number;
  /** 0 when the request asked for all rows. */
  limit: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number | null;
  prevPage: number | null;
  docs: FeatureResponseDto[];
};
export type CreateFeatureDto = {
  /** `^feature_[a-z0-9_]+$`; cannot change afterwards. Wrong format answers `INVALID_FEATURE_KEY` (90052). */
  key: string;
  name: string;
  description?: string | null;
};
export type FeatureRuleInputDto = {
  type: 'entity' | 'country' | 'region' | 'group';
  /** entity: entity uuid; country: ISO 3166-1 alpha-2; region: VSI / VSA / TW / VSE; group: entity group id. Case-insensitive. */
  value: string;
};
export type UpdateFeatureDto = {
  mode?: 'all' | 'restricted' | 'none';
  /** Added in the same transaction as `mode`. Required when switching to `restricted` with an empty list (`RULE_REQUIRED`, 90055). Existing rules are skipped. */
  rules?: FeatureRuleInputDto[];
  /** Note for every rule in `rules`. */
  note?: string;
  name?: string;
  description?: string | null;
};
export type FeatureRuleGroupDto = {
  name: string;
  memberCount: number;
};
export type FeatureRuleResponseDto = {
  id: string;
  type: 'entity' | 'country' | 'region' | 'group';
  /** For `group`: the group id. */
  value: string;
  /** Always set for `group`, null otherwise. */
  group: FeatureRuleGroupDto | null;
  note: string | null;
  createdBy: string;
  createdAt: string;
};
export type ListFeatureRulesResponseDto = {
  totalDocs: number;
  totalPages: number;
  /** 1-based. */
  page: number;
  /** 0 when the request asked for all rows. */
  limit: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number | null;
  prevPage: number | null;
  docs: FeatureRuleResponseDto[];
};
export type SkippedFeatureRuleDto = {
  type: 'entity' | 'country' | 'region' | 'group';
  value: string;
  reason: 'RULE_ALREADY_EXISTS';
};
export type AddFeatureRulesResponseDto = {
  created: FeatureRuleResponseDto[];
  /** Already on the list (or repeated in the batch). */
  skipped: SkippedFeatureRuleDto[];
};
export type AddFeatureRulesDto = {
  rules: FeatureRuleInputDto[];
  /** Note for every rule in this batch. */
  note?: string;
};
export type EntityGroupResponseDto = {
  id: string;
  name: string;
  description: string | null;
  memberCount: number;
  /** How many features have a rule pointing at this group. */
  usedByCount: number;
  /** Email. */
  createdBy: string;
  /** Equals createdBy on create; afterwards whoever last changed the name, description or members. */
  updatedBy: string;
  updatedAt: string;
};
export type ListEntityGroupsResponseDto = {
  totalDocs: number;
  totalPages: number;
  /** 1-based. */
  page: number;
  /** 0 when the request asked for all rows. */
  limit: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number | null;
  prevPage: number | null;
  docs: EntityGroupResponseDto[];
};
export type CreateEntityGroupDto = {
  /** Trimmed; unique ignoring case (`ENTITY_GROUP_NAME_EXISTS`, 90068). Blank answers 400. */
  name: string;
  description?: string | null;
};
export type EntityGroupUsedByDto = {
  key: string;
  name: string;
  mode: 'all' | 'restricted' | 'none';
};
export type EntityGroupDetailResponseDto = {
  id: string;
  name: string;
  description: string | null;
  memberCount: number;
  /** Features using the group, by key. */
  usedBy: EntityGroupUsedByDto[];
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
};
export type UpdateEntityGroupDto = {
  /** Trimmed; unique ignoring case. Rules using the group follow it. */
  name?: string;
  /** null clears it; leave it out to keep it. */
  description?: string | null;
};
export type EntityGroupMemberResponseDto = {
  id: string;
  /** Lowercase. */
  entityId: string;
  note: string | null;
  createdBy: string;
  createdAt: string;
};
export type ListEntityGroupMembersResponseDto = {
  totalDocs: number;
  totalPages: number;
  /** 1-based. */
  page: number;
  /** 0 when the request asked for all rows. */
  limit: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number | null;
  prevPage: number | null;
  docs: EntityGroupMemberResponseDto[];
};
export type SkippedEntityGroupMemberDto = {
  entityId: string;
  reason: 'MEMBER_ALREADY_EXISTS';
};
export type AddEntityGroupMembersResponseDto = {
  created: EntityGroupMemberResponseDto[];
  /** Already in the group (or repeated in the batch). */
  skipped: SkippedEntityGroupMemberDto[];
};
export type AddEntityGroupMembersDto = {
  /** Entity uuids, case-insensitive. One invalid id rejects the whole batch. */
  entityIds: string[];
  /** Note for every member in this batch. */
  note?: string;
};
export const {
  useCapabilityControllerListDeviceModelsQuery,
  useCapabilityControllerCreateDeviceModelMutation,
  useCapabilityControllerGetDeviceModelQuery,
  useCapabilityControllerUpdateDeviceModelMutation,
  useCapabilityControllerDeleteDeviceModelMutation,
  useCapabilityControllerListCapabilityKeysQuery,
  useCapabilityControllerCreateCapabilityKeyMutation,
  useCapabilityControllerUpdateCapabilityKeyMutation,
  useCapabilityControllerDeleteCapabilityKeyMutation,
  useCapabilityControllerListCapabilityVersionsQuery,
  useCapabilityControllerCreateCapabilityVersionMutation,
  useCapabilityControllerDeleteCapabilityVersionMutation,
  useCapabilityControllerListDeviceCapabilitiesQuery,
  useCapabilityControllerBulkUpdateDeviceCapabilitiesMutation,
  useCapabilityControllerUpdateDeviceCapabilityMutation,
  useCapabilityControllerDeleteDeviceCapabilityMutation,
  useFeatureControllerListQuery,
  useFeatureControllerCreateMutation,
  useFeatureControllerGetQuery,
  useFeatureControllerUpdateMutation,
  useFeatureControllerListRulesQuery,
  useFeatureControllerAddRulesMutation,
  useFeatureControllerDeleteRuleMutation,
  useEntityGroupControllerListQuery,
  useEntityGroupControllerCreateMutation,
  useEntityGroupControllerGetQuery,
  useEntityGroupControllerUpdateMutation,
  useEntityGroupControllerDeleteMutation,
  useEntityGroupControllerListMembersQuery,
  useEntityGroupControllerAddMembersMutation,
  useEntityGroupControllerDeleteMemberMutation,
} = injectedRtkApi;
